import portrait from './portrait';
import departmentInitExamine from './portrait/departmentInitExamine';
import schoolInitExamine from './portrait/schoolInitExamine';
import alterationExamine from './portrait/schoolAlterationExamine';
import completeExamine from './portrait/completeExamine';
import transverse from './transverse';
import setting from './setting';
import departmentAlterationExamine from './portrait/departmentAlterationExamine';
import departmentCompleteExamine from './portrait/departmentCompleteExamine';
import collect from './collect';
import schoolProject from './schoolProject';
import applyProject from './applyProject';


export default {
    portrait,
    departmentInitExamine,
    schoolInitExamine,
    alterationExamine,
    completeExamine,
    transverse,
    setting,
    departmentAlterationExamine,
    departmentCompleteExamine,
    collect,
    applyProject,
    schoolProject


}